(function () {
  var drawer = document.getElementById('t4s-size-guide');
  if (!drawer) return;

  var contentEl = document.getElementById('size-guide-drawer-content');
  var triggersSelector = '[data-size-guide-open], .t4s-btn__size-chart';
  var STORAGE_KEY_PREFIX = 'sizeGuideHTML:v1:';

  function getKey(url) { return STORAGE_KEY_PREFIX + (url || ''); }

  function setCached(url, html) {
    try { sessionStorage.setItem(getKey(url), html); } catch (e) {}
  }
  function getCached(url) {
    try { return sessionStorage.getItem(getKey(url)); } catch (e) { return null; }
  }

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('t4s-size-guide-open', 't4s-drawer-open');
    var closeBtn = drawer.querySelector('[data-size-guide-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('t4s-size-guide-open', 't4s-drawer-open');
  }

  function extractSection(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var sec = tmp.querySelector('#shopify-section-framing-size-guide');
    return (sec ? sec.innerHTML : html);
  }

  function render(html) {
    if (!contentEl) return;
    contentEl.innerHTML = html;
  }

  function fetchSection(url, onDone) {
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var inner = extractSection(html);
        setCached(url, inner);
        if (onDone) onDone(inner);
      })
      .catch(function () {
        if (onDone) onDone('<p style="padding:10px">Sorry, failed to load the size guide.</p>');
      });
  }

  function loadSection(url) {
    var cached = getCached(url);
    if (cached) {
      render(cached);
      // Quietly refresh cache in the background (optional)
      fetchSection(url);
      return;
    }
    render('<div class="t4s-spinner" aria-label="Loading"></div>');
    fetchSection(url, render);
  }

  // CLICK (open + load)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(triggersSelector);
    if (!trigger) return;

    if (e.type === 'click' && (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return;
    e.preventDefault();
    e.stopPropagation();

    var url = trigger.getAttribute('data-size-guide-url') ||
              trigger.getAttribute('href') ||
              (window.location.pathname + '?section_id=framing-size-guide');

    openDrawer();
    loadSection(url);
  });

  // CLOSE
  drawer.addEventListener('click', function (e) {
    if (e.target.matches('[data-size-guide-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  // ---- PREFETCH STRATEGIES ----
  function prefetch(url) {
    if (!url || getCached(url)) return;
    fetchSection(url); // warms sessionStorage
  }

  // 1) Prefetch when trigger is visible
  var trigger = document.querySelector(triggersSelector);
  if (trigger) {
    var url = trigger.getAttribute('data-size-guide-url') ||
              trigger.getAttribute('href') ||
              (window.location.pathname + '?section_id=framing-size-guide');

    // a) when it enters viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (ent) {
          if (ent.isIntersecting) { prefetch(url); io.disconnect(); }
        });
      }, { rootMargin: '200px' });
      io.observe(trigger);
    } else {
      // fallback: after a short idle
      setTimeout(function(){ prefetch(url); }, 800);
    }

    // b) and on hover / touchstart (first intent)
    ['mouseenter','touchstart','focus'].forEach(function(evt){
      trigger.addEventListener(evt, function(){ prefetch(url); }, { once:true, passive:true });
    });

    // c) and during browser idle (extra safety)
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function(){ prefetch(url); }, { timeout: 2000 });
    } else {
      setTimeout(function(){ prefetch(url); }, 1500);
    }
  }
})();
